export default __webpack_public_path__ + "static/media/26popup.80d4699a.jpg";